module.exports = __webpack_public_path__ + "static/img/s_8.61da1bf5.png";